import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gallery-top-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "button button--navigate",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onNavigate && _ctx.onNavigate(...args)))
    }),
    (_ctx.showStreetView)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "button button--streetview",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onStreetView && _ctx.onStreetView(...args)))
        }))
      : _createCommentVNode("", true),
    (_ctx.virtualTourLink)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "button button--view3d",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onVirtualTour && _ctx.onVirtualTour(...args)))
        }))
      : _createCommentVNode("", true),
    (_ctx.videoLink)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          class: "button button--video",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onVideo && _ctx.onVideo(...args)))
        }))
      : _createCommentVNode("", true)
  ]))
}